var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Lifekey",class:{ completed: _vm.completed }},[_c('svgicon',{attrs:{"icon":"key-3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }